import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: null,
  refreshToken: null,
  loading: false,
  error: null,
  // hydrated=false until /auth/me rehydrates on hard refresh (or clearAuth confirms no session).
  // ProtectedRoute waits on this to avoid racing to /login before rehydration finishes.
  hydrated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken || null;
      state.error = null;
      state.hydrated = true;
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.error = null;
      state.hydrated = true;
    },
  },
});

export const { setAuth, updateUser, setLoading, setError, clearAuth } = authSlice.actions;
export default authSlice.reducer;
